export enum MenuItemType {
  Function = 'Function',
  Link = 'Link',
  Blank = 'Blank',
  InfoText = 'InfoText',
  Heading = 'Heading'
}
